import { ResetPasswordSubmit } from 'api/generated';
import { IdentityService } from 'api/generated/services/IdentityService';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

export type IdentityPasswordSubmitInput = {
  userCode: string;
  requestBody?: ResetPasswordSubmit;
};

export const useIdentityUsersPasswordResetSubmitMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof IdentityService.postIdentityUsersPasswordResetSubmit>>,
      unknown,
      {
        input: IdentityPasswordSubmitInput;
      },
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    ({ input: input }) => IdentityService.postIdentityUsersPasswordResetSubmit(input.userCode, input.requestBody),
    {
      ...options,
      onSuccess: () => {
        toast.success('Your password has been successfully reset.');
      }
    }
  );
